import React from "react";
import { Layout } from "../layout/Layout.js";
import { TemplatesList } from "./TemplatesList.js";

/**
 * Shows the templates list page.
 */
export const TemplatesPage = () => {
  return (
    <Layout title="Vormid" containerWidth="fixed-wide-min">
      <h2>Vormid</h2>
      <TemplatesList />
    </Layout>
  );
};
